const updateURLParameter = (url, param, paramVal) => {
  let tempArray = url.split('?');
  const baseURL = tempArray[0];
  const additionalURL = tempArray[1];
  let newAdditionalURL = '';
  let temp = '&';
  let newParams = '';
  let index = 0

  if (additionalURL) {
    tempArray = additionalURL.split('&');
    for (let i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split('=')[0].split('%5B')[0] !== param) {
        if (index === 0) {
          newAdditionalURL += tempArray[i];
        } else {
          newAdditionalURL += temp + tempArray[i];
        }
        index++;
      }
    }
  }

  if (typeof paramVal === 'object' && paramVal) {
    paramVal.forEach((value, index) => {
      if (newAdditionalURL.length > 0 || index > 0) {
        newParams += `${temp}${param}%5B%5D=${value.id}`;
      } else {
        newParams += `${param}%5B%5D=${value.id}`;
      }
    });
  } else {
    if (paramVal) {
      if (newAdditionalURL.length > 0) {
        newParams += `${temp}${param}=${paramVal}`;
      } else {
        newParams += `${param}=${paramVal}`;
      }
    }
  }

  return baseURL + (newAdditionalURL.length > 0 || newParams.length > 0 ? '?' : '') + newAdditionalURL + newParams;
}

export default updateURLParameter;
